<template>
  <div class="kydt">
    <div class="title1" v-show="showList">导师队伍</div>
    <div v-if="showList" class="box">

      <el-table :data="newList">
        <el-table-column label="姓名" >
          <template slot-scope="scope">
            {{ scope.row.dynamic_data.name }}
          </template>
        </el-table-column>
        <el-table-column label="职务" >
          <template slot-scope="scope">
            {{ scope.row.dynamic_data.professional }}
          </template>
        </el-table-column>
        <el-table-column label="所属单位" >
          <template slot-scope="scope">
            {{ scope.row.dynamic_data.unit }}
          </template>
        </el-table-column>
        <el-table-column label="邮箱" >
          <template slot-scope="scope">
            {{ scope.row.dynamic_data.mailbox }}
          </template>
        </el-table-column>
      </el-table>
      <!-- <div class="title clearfix">
        <div>姓名</div>
        <div>职务</div>
        <div>所属单位</div>
        <div>邮箱</div>
      </div>
      <div class="title clearfix" v-for="(x, index) in newList" :key="index">
        <div>{{ x.dynamic_data.name }}</div>
        <div>{{ x.dynamic_data.professional }}</div>
        <div>{{ x.dynamic_data.unit }}</div>
        <div>{{ x.dynamic_data.mailbox }}</div>
      </div> -->
    </div>
    <detailVue :articleId="article_id" v-if="!showList"></detailVue>
  </div>
</template>
<script>
import detailVue from '../../components/detail.vue';
import listUser from '../../components/listUser.vue';
export default {
  components: {
    listUser,
    detailVue
  },
  data() {
    return {
      showList: true,
      column_id: '',
      article_id: '',
      newList: []
    }
  },
  created() {
    this.column_id = this.$route.query.column_id
    this.getList()
  },
  methods: {
    detail(item) {
      if (item.redirection_address) {
        window.open(item.redirection_address);
      } else {
        this.article_id = item.article_id
        this.showList = false
      }
    },
    getList() {
      let self = this
      this.newList = []
      this.$common.noLoginCallUrl('/api/cp-cms/site/info/getInfoPage', {
        column_id: this.column_id,
        // pageNo:self.currentPage,
        // pageCount:self.pageSize
      },
        function (res) {
          if (res.code == '000000') {
            self.newList = res.data.data
          } else {
            self.$message.warning(res.msg)
          }
        })
    },
    onPopState(e) {
      this.$router.replace({ path: '/' })
    },
  },
  mounted() {
    // 添加 popstate 事件监听
    window.history.pushState(null, null, window.location.href);
    window.addEventListener('popstate', this.onPopState);
  },
  beforeDestroy() {
    // 在组件销毁前，移除 popstate 事件监听
    window.removeEventListener('popstate', this.onPopState)
  },
  watch: { // 监听，当路由发生变化的时候执行
    $route(to, from) {
      this.showList = true
    }
  }
};
</script>

<style lang="less" scoped>
.kydt {
  padding: 0 40px;

  // overflow: auto;
  .box {
    margin: 40px 0;

    .title {
      div {
        float: left;
        width: 25%;
      }

    }
  }

  .title1 {
    text-align: center;
    font-size: 22px;
    margin: 10px 0 30px;
  }
}

@media screen and (max-width: 1025px) {
  .kydt {
    padding: 0;
  }
  /deep/ .el-table__header-wrapper table {
    width: 100% !important;
  }
}
</style>